webpackJsonp([36464171217369],{

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookRedux = __webpack_require__(38);
	
	var _LoreHookRedux2 = _interopRequireDefault(_LoreHookRedux);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookRedux2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'enhancer'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Enhance the store with third-party capabilities such as middleware, time travel, persistence, etc.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'http://redux.js.org/docs/api/compose.html' },
	        'http://redux.js.org/docs/api/compose.html'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Note about the batchedSubscribe enhancer:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When normalization is configured and enabled, action creators can end up firing multiple actions back-to-back. By default, these actions do not get batched by Redux (it notifies React that the store changed after every action), which means every action will cause React to re-render the application. When this occurs back-to-back over a very short period of time, the responsiveness (and usability) of the application can drop noticeably.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The batchedSubscribe enhancer, combined with the use of the _.debounce function, is a way of preventing this behavior, by preventing Redux from notifying React about changes to the Store until at least X time has passed between updates.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore sets this value to 0 by default, which translates to "one tick". This delay should be undetectable to users, but just long enough to make sure that all actions from a normalized response are processed before React is notified of the change.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      enhancer: function(middleware, config) {\n        return Redux.compose(\n          Redux.applyMiddleware.apply(null, middleware),\n          batchedSubscribe(_.debounce(function(notify) {\n            notify();\n          }, config.redux.debounceWait))\n        );\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-redux-config-enhancer-js-fccf4a944e5b54124815.js